var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.loading)?_c(_setup.LoadingSpinner):_c(_setup.PostSigning,_vm._b({attrs:{"branding":_setup.branding}},'PostSigning',_setup.messaging,false))
}
var staticRenderFns = []

export { render, staticRenderFns }